import { Carto } from '../common/carte/carte-config.js';
import { init as initDossier } from '../dossier/dossier-preview.js';
import { init as initIllustration } from '../illustration/illustration-preview.js';

import { Panel } from './listing-panel.js';

export class PreviewPanel extends Panel {
  constructor(previewContainer, onElementSelected) {
    super();

    this.previewContainer = previewContainer;
    this.onElementSelected = onElementSelected;
  }

  setElement(element) {
    super.setElement(element);

    this.onElementSelected(element);

    this.manageElement(element);
  }

  async manageElement(element) {
    Carto.dossierGeoref = null;

    // Chaque élément a un attribut data-preview-url contenant l'URL d'accès à son aperçu
    const previewUrl = element.getAttribute('data-preview-url');
    try {
      const headers = new Headers({
        // Header custom pour indiquer qu'on ne souhaite pas récupérer une page complète
        'X-HTML-FRAGMENT': 'true',
      });
      const response = await fetch(previewUrl, { headers });
      this.previewContainer.innerHTML = await response.text();

      if (!response.ok) {
        return;
      }

      if (element.getAttribute('data-type') === 'illustration') {
        initIllustration();
      } else {
        initDossier();
      }
      this.checkDetailsActions();
    } catch (error) {
      console.error(error);
      // TODO: Ajouter un message d'erreur côté UI ?
    }
  }

  checkDetailsActions() {
    super.checkDetailsActions();

    // On active / désactive les onglets Aperçu et Carte selon le type de l'entité courante
    const openPreviewTab = document.querySelector(
      '.search-results-preview [data-action="search-result-details:open-preview-tab"]',
    );
    openPreviewTab.removeAttribute('disabled');
    openPreviewTab.classList.add('active-tab');

    if (this.currentElement.matches('[data-type="dossier"]')) {
      const openMapTab = document.querySelector(
        '.search-results-preview [data-action="search-result-details:open-carto-tab"]',
      );
      openMapTab.removeAttribute('disabled');
    }
  }
}
